import s from "classnames/bind";
const i = (r) => {
  const t = r ? s.bind(r) : s;
  return (...n) => t(
    ...n.filter(Boolean).map((e) => typeof e == "string" ? e.split(" ") : e)
  );
}, m = (...r) => r.reduce((t, n) => {
  for (const e in n)
    t[e] = t[e] ? `${t[e]} ${n[e]}` : n[e] ?? "";
  return t;
}, {});
export {
  i as makeClassesByStyles,
  m as mergeStyles
};
